import { startRouter } from './router';

const root = document.getElementById('app');
if (!root) {
  throw new Error('#app root element not found');
}
startRouter(root);
